import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=34050547&scoped=true"
import script from "./Workflows.vue?vue&type=script&lang=js"
export * from "./Workflows.vue?vue&type=script&lang=js"
import style0 from "./Workflows.vue?vue&type=style&index=0&id=34050547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34050547",
  null
  
)

export default component.exports